import { BaseShape, type BaseShapeProps } from "./BaseShape";

type CircleProps = Omit<BaseShapeProps, "children"> & {
    circleProps?: React.SVGProps<SVGCircleElement>;
    textProps?: React.SVGProps<SVGTextElement>;
    radius?: number;
    fontSize?: number;
    textOffsetX?: number;
    textOffsetY?: number;
};

export function Circle({
    label,
    onClick,
    mainProps,
    circleProps,
    textProps,
    radius = 20,
    enableTooltip,
    tooltipContent,
    tooltipClassName,
    fontSize = 10,
    textOffsetX = 0,
    textOffsetY = 0,
}: CircleProps) {
    return (
        <BaseShape
            label={label}
            onClick={onClick}
            mainProps={mainProps}
            enableTooltip={enableTooltip}
            tooltipContent={tooltipContent}
            tooltipClassName={tooltipClassName}
        >
            {({ x, y }) => (
                <>
                    <circle
                        cx={x}
                        cy={y}
                        r={radius}
                        className={circleProps?.className || "fill-[#BDBBE0]"}
                        {...circleProps}
                    />
                    {label && (
                        <text
                            x={x - textOffsetX}
                            y={y - textOffsetY}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fontSize={fontSize}
                            className={textProps?.className || "fill-[#000000]"}
                            style={{ userSelect: "none", ...textProps?.style }}
                            {...textProps}
                        >
                            {label}
                        </text>
                    )}
                </>
            )}
        </BaseShape>
    );
}
